import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.less';

const ProvisionalBtnImage = ({ label, icon, isActive, onClick }) => (
  <button
    type="button"
    aria-pressed={isActive}
    onClick={onClick}
    className={cx(styles.btnImage, {
      [styles.btnImageActive]: isActive,
    })}
  >
    {icon ? (
      <img
        src={icon}
        alt={label}
        className={cx(styles.btnImageIcon, 'zolaicon')}
        style={{ width: '35px' }}
      />
    ) : null}
    <div
      className={cx(styles.btnImageLabel, {
        [styles.btnImageLabelActive]: isActive,
      })}
    >
      <span>{label}</span>
    </div>
  </button>
);

ProvisionalBtnImage.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ProvisionalBtnImage;
